import React from 'react';
import { MenuItem, TextField } from '@material-ui/core';
import NavResponsiveModal, {
    ModalActions,
    ModalContent,
    ModalHeader,
} from '@/components/Navigation/NavResponsiveModal';
import { PrimaryButton, SecondaryButton } from '@/styles/blocks';
import { TARIFF_CATEGORIES, UNTAGGED_LABEL } from './constants';
import { useAddTariffForm } from './hooks';
import CommodityToggles from './CommodityToggles';
import { FormLabel, FormStack } from './blocks';

const AddTariffModal = ({ open, algoTypeOptions, onClose, onCreate }) => {
    const { form, canCreate, callbacks } = useAddTariffForm({ open, onCreate, onClose });

    return (
        <NavResponsiveModal open={open} onClose={onClose}>
            <ModalHeader title="Add Tariff" onClose={onClose} />
            <ModalContent>
                <FormStack>
                    {/* The ids let MUI link each label to its select, which is what names the field. */}
                    <TextField
                        id="add-tariff-type"
                        select
                        size="small"
                        variant="outlined"
                        label="Type"
                        value={form.algo_type}
                        onChange={(e) => callbacks.setAlgoType(e.target.value)}
                    >
                        {(algoTypeOptions || []).map((algo) => (
                            <MenuItem key={algo.value} value={algo.value}>
                                {algo.label}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        id="add-tariff-category"
                        select
                        size="small"
                        variant="outlined"
                        label="Category"
                        value={form.category}
                        onChange={(e) => callbacks.setCategory(e.target.value)}
                        SelectProps={{ displayEmpty: true }}
                        InputLabelProps={{ shrink: true }}
                    >
                        <MenuItem value="">{UNTAGGED_LABEL}</MenuItem>
                        {TARIFF_CATEGORIES.map((category) => (
                            <MenuItem key={category.value} value={category.value}>
                                {category.label}
                            </MenuItem>
                        ))}
                    </TextField>
                    <FormLabel>Commodities</FormLabel>
                    <CommodityToggles value={form.commodity_tags} onToggle={callbacks.toggleCommodity} />
                </FormStack>
            </ModalContent>
            <ModalActions>
                <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
                <PrimaryButton disabled={!canCreate} onClick={callbacks.create}>
                    Create
                </PrimaryButton>
            </ModalActions>
        </NavResponsiveModal>
    );
};

export default AddTariffModal;
